import { render, staticRenderFns } from "./claim_detail_title.vue?vue&type=template&id=4d47436f&scoped=true"
import script from "./claim_detail_title.vue?vue&type=script&lang=js"
export * from "./claim_detail_title.vue?vue&type=script&lang=js"
import style0 from "./claim_detail_title.vue?vue&type=style&index=0&id=4d47436f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d47436f",
  null
  
)

export default component.exports